import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield\n  (if\n    this.doesNotSupportIntersectionObserver null this.intersectionObserverProxy\n  )\n}}")